/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const useYeguere = () => {
  const token = localStorage.getItem("@Token");
  const [yeguere, setYeguere] = useState([]);
  const getYeguere = async () => {
    try {
      const response = await api.get("api/empaque/yegueres/?all=false", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + token,
        },
      });
      setYeguere(response.data);
    } catch (error) {
      setYeguere([]);
      console.log(error);
    }
  };

  useEffect(() => {
    getYeguere();
  }, []);

  return { yeguere };
};
